import { Link } from 'react-router-dom';
import type { BlogInlinePart } from '../../data/blog';

interface BlogRichTextProps {
  parts: readonly BlogInlinePart[];
  className?: string;
}

export function BlogRichText({ parts, className }: BlogRichTextProps) {
  return (
    <p className={className}>
      {parts.map((part, index) => {
        if (part.type === 'text') {
          return <span key={`${index}-${part.value.slice(0, 24)}`}>{part.value}</span>;
        }

        if (part.external || part.href.startsWith('http')) {
          return (
            <a
              key={`${index}-${part.href}`}
              href={part.href}
              className="blog-post__inline-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {part.label}
            </a>
          );
        }

        return (
          <Link key={`${index}-${part.href}`} to={part.href} className="blog-post__inline-link">
            {part.label}
          </Link>
        );
      })}
    </p>
  );
}
